import React from "react";
import "./SportsDocuments.css";

const SportsDocuments = () => {
  return (
    <div className="sports-documents-section">
      <div className="sports-documents-container">
        <h1 className="sports-documents-title"> TPL -Talented Premier League</h1>
        <h2 className="sports-documents-subtitle">Sports Participant Eligibility Proofs</h2>
        <p className="sports-documents-intro">
          To ensure fair participation and smooth event management, all athletes are required to provide the following documents before the competition.
        </p>

        <div className="sports-doc-card">
          <h6>1. Player ID Proof <span>(*)</span></h6>
          <p>Valid government-issued identification is required for verification of player details.</p>
          <ul>
            <li>Aadhaar Card</li>
            <li>Passport</li>
            <li>Voter ID</li>
            <li>School / College ID</li>
          </ul>
        </div>

        <div className="sports-doc-card">
          <h6>2. Recent Photograph</h6>
          <p>A recent passport-size photo must be submitted for the athlete badge and profile record.</p>
        </div>

        <div className="sports-doc-card">
          <h6>3. Medical Fitness Certificate</h6>
          <p>
            A certificate issued by a registered medical practitioner confirming the participant’s physical fitness to compete in sports events.
          </p>
        </div>

        <div className="sports-doc-card">
          <h6>4. Parental Consent Form <span>(Under 18)</span></h6>
          <p>Participants below 18 years must submit a signed4parental consent form authorizing participation.</p>
        </div>

        <div className="sports-doc-card">
          <h6>5. Team Authorization Letter</h6>
          <p>
            If representing a school, college, or club, an official authorization letter signed by the institution head or coach must be produced.
          </p>
        </div>

        <div className="sports-doc-card">
          <h6>6. Address Proof</h6>
          <p>For communication and certificate delivery purposes, players may optionally submit address proof.</p>
        </div>

        <div className="sports-documents-note">
          <strong>Note:</strong> All documents must be submitted at the time of registration or during the verification desk on the event day.  
          Originals may be requested for cross-checking.
        </div>
      </div>
    </div>
  );
};

export default SportsDocuments;
